import { Components, Theme } from '@mui/material/styles';

const cardTheme: Components<Theme>['MuiCard'] = {
  defaultProps: {
    square: true,
  },
  styleOverrides: {
    root: {
      border: '1px solid grey',
    },
  },
};

export default cardTheme;
